import React, {useState} from 'react';
import {Button, Menu, MenuItem} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {CREATE_CUSTOMER} from "../../../constants/eInvoicePermissions";
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";

function CustomerListPageActions() {
    const navigate = useNavigate();
    const {hasEInvoicePermission} = usePermissions();
    const accessDeniedMessage = useAccessDeniedMessage();
    const canCreate = hasEInvoicePermission(CREATE_CUSTOMER);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCreateAction = (type) => {
        navigate(`/customers/create?customerType=${type}`);
    };

    return (
        <>
            <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
                <Button
                    data-testid="create-customer-button"
                    key="add-new-customer"
                    variant="contained"
                    disabled={!canCreate}
                    color="primary"
                    onClick={handleClick}
                >
                    {'+ Create New Customer'}
                </Button>
            </PermissionDeniedWrapper>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem data-testid="create-individual-customer" onClick={() => handleCreateAction('INDIVIDUAL')}>
                    {'Individual Customer'}
                </MenuItem>
                <MenuItem data-testid="create-business-customer" onClick={() => handleCreateAction('BUSINESS')}>
                    {'Business Customer'}
                </MenuItem>
            </Menu>
        </>
    );
}

export default CustomerListPageActions;
